import AsyncStorage from '@react-native-async-storage/async-storage';
import * as _ from 'lodash';

const Reducer = (state, action) => {
    switch (action.type) {
        case 'SET_HISTORY':
            let _items = []
            if(action.payload) {
                _items = action.payload.map(item => {
                    if(item && item.sellers) {
                        let arr = []
                        for(var i in item.sellers) {
                            if(item.sellers[i].status==='active') {
                                arr.push(item.sellers[i])
                            }
                        }
                        if (arr.length) {
                            item['pricetag'] = {
                                mpu: arr[0].mpu,
                                price: arr[0].price,
                            }
                        // } else {
                        //     item['pricetag'] = {
                        //         mpu: item.mpu,
                        //         price: item.price
                        //     }
                            return item
                        }
                        return null
                    // } else {
                    //     item['pricetag'] = {
                    //         mpu: item.mpu,
                    //         price: item.price
                    //     }
                    }
                    return null
                });
            }
            _items = _items.filter(item => item !== null)

            return {
                ...state,
                product_history: _items
            };
        case 'CLEAR_ALL':
            AsyncStorage.removeItem('productHistory')
            
            return {
                ...state,
                product_history: [],
            }
        default:
            return state;
    }
};

export default Reducer;